import type { FC, ReactNode, CSSProperties } from 'react';
import classnames from 'classnames';

import style from './style.scss';

type TagColor = 'green' | 'red' | 'grey' | 'orange' | 'blue' | 'dark_grey';

interface Props {
  children: ReactNode;
  color?: TagColor;
  filled?: boolean;
  className?: string;
  style?: CSSProperties;
}

const colorClassMap: { [key in TagColor]: string } = {
  green: style.tag_green,
  red: style.tag_red,
  grey: style.tag_grey,
  orange: style.tag_orange,
  blue: style.tag_blue,
  dark_grey: style.tag_darkGrey
};

const Tag: FC<Props> = ({ children, color = 'green', filled, className, style: css }) => {
  const tagClassName = classnames(style.tag, colorClassMap[color], className, {
    [style.tag_filled]: filled
  });

  return (
    <div className={tagClassName} style={css}>
      {children}
    </div>
  );
};

Tag.displayName = 'Tag';

export default Tag;
